import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TitanIconComponent } from '../titan-icon/titan-icon.component';

@Component({
  selector: 'app-titan-avatar',
  templateUrl: './titan-avatar.component.html',
  styleUrls: ['./titan-avatar.component.scss'],
  standalone: true,
  imports: [TitanIconComponent, NgIf]
})
export class TitanAvatarComponent {
  @Input() account?: string;

  get firstLetter() {
    return this.account?.charAt(0).toUpperCase() || '';
  }
}
